import clsx from "clsx";
import { Group } from "core/models/Group";
import { Tournament } from "core/models/Tournament";
import { getDate, getTime } from "core/utils/Date";
import { Tag } from "rsuite";

interface PannelHeaderProps {
  tournament: Tournament;
}

export default function BracketPlayOffDetailCard({
  tournament,
}: PannelHeaderProps) {
  return (
    <div
      className={clsx(
        "play-off-detail-card-container"
      )}
    >
      <div className="play-off-detail-card-wrapper">
        <div className="game-tournamentImage-container">
          <img
            src={tournament?.content?.icon}
            alt="Tournament"
            className="game-tournament-image"
          />
          <div className="play-off-tournament-name">
            <div className="name">{tournament?.title}</div>
          </div>
        </div>
        <div className="play-off-detail-container">
          <div className="play-off-tournament-detail">
            <div className="tournament-detail-info">
              <div className="info-text">Start Date and Time:</div>
              <div className="info-value-text">
                {" "}
                {getDate(tournament?.startDate, "MMM DD, YYYY hh:mm")}
              </div>
            </div>
            <div className="tournament-detail-info">
              <div className="info-text">Moderator:</div>
              <div className="info-value-text">
                {tournament?.moderatorCount}
              </div>
            </div>
            <div className="tournament-detail-info">
              <div className="info-text">Type:</div>
              <div className="info-value-text">{tournament?.type}</div>
            </div>
            <div className="tournament-detail-info">
              <div className="info-text">Bracket Type:</div>
              <div className="info-value-text">{tournament?.bracketType}</div>
            </div>
            <div className="tournament-detail-info">
              <div className="info-text">Current Round:</div>
              <div className="info-value-text">{tournament?.currentRound}</div>
            </div>

            <div className="tournament-detail-info">
              <div className="info-text">Status:</div>
              <div className={clsx("info-value-text")}>
                {tournament?.completed ? (
                  <Tag color="green" className="tournament-detail-status">
                    COMPLETED
                  </Tag>
                ) : (
                  <Tag color="red" className="tournament-detail-status">
                    LIVE
                  </Tag>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
